import { render, staticRenderFns } from "./NewOnboardingButton.vue?vue&type=template&id=675a4bad&scoped=true&"
import script from "./NewOnboardingButton.vue?vue&type=script&lang=js&"
export * from "./NewOnboardingButton.vue?vue&type=script&lang=js&"
import style0 from "./NewOnboardingButton.vue?vue&type=style&index=0&id=675a4bad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675a4bad",
  null
  
)

export default component.exports